import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AdminGuard from "./adminGuard";

import useAuth from "../../hooks/useAuth";

const AuthGuard = ({ children }) => {
  const { isLoggedIn, setAuthState } = useAuth();
  const navigate = useNavigate();

  //const roles = ["Administrador", "Vendedor"];

  useEffect(() => {
    const isLoggedInLocal = localStorage.getItem("serviceToken");

    if (!isLoggedIn || !isLoggedInLocal) {
      navigate("/auth/signin", { replace: true });
    } else {
      
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "serviceToken") {
        const isLoggedInLocal = !!localStorage.getItem("serviceToken");
        setAuthState({
          isLoggedIn: isLoggedInLocal,
          user: isLoggedInLocal ? isLoggedIn : null,
        });

        if (!isLoggedInLocal) {
          navigate("/auth/signin", { replace: true });
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate, setAuthState, isLoggedIn]);

  useEffect(()=>{
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === 't') {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    }

  },[])

  return <React.Fragment>{children}<AdminGuard/></React.Fragment>;
};

export default AuthGuard;
